<template>
  <div class="vehicle-info-container">
    <div :class="wrapperCSSClasses">
      <div class="row py-4">
        <div class="col-8">
          <p data-cy="vehicleName" class="font-weight-bold m-0">{{ vehicleString }}</p>
        </div>
        <div v-if="displayVehiclePrice && vehicleInfo.price" class="col-4 text-right">
          <p data-cy="vehiclePrice" class="m-0">{{ $n(vehicleInfo.price, 'currencyDollars', languageCode) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'VehicleInfo',
  data() {
    return {};
  },
  props: {
    displayVehiclePrice: {
      type: Boolean,
      default: true,
    },
    wrapperCSSClasses: {
      type: String,
      default: 'smaller-container-wrapper',
    },
  },
  computed: {
    ...mapGetters({
      vehicleString: 'vehicle/vehicleString',
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    ...mapState('vehicle', ['vehicleInfo']),
  },
};
</script>

<style lang="scss" scoped>
.vehicle-info-container {
  background-color: #f0f4f7;
}
</style>
